import { incubeta } from './incubeta/config';
import type { ClientConfig } from './types';

// Adding a tenant = one folder + one line here.
export const configs: readonly ClientConfig[] = [incubeta];
